// Slugify a string to xxx_xxx format (lowercase, spaces to underscores, remove non-alphanumerics except _)
export function slugify(str: string): string {
    return str
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '_') // spaces to underscores
}
